import { render, staticRenderFns } from "./CalendarNotification.vue?vue&type=template&id=3b8b67e2&"
import script from "./CalendarNotification.vue?vue&type=script&lang=js&"
export * from "./CalendarNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports